var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9238 6.88873C23.9238 3.25539 20.9785 0.310059 17.3458 0.310059C15.1405 0.310059 13.1945 1.39873 12.0005 3.06273C10.8065 1.39873 8.86048 0.310059 6.65582 0.310059C3.02248 0.310059 0.0771484 3.25473 0.0771484 6.88873C0.0771484 7.40339 0.142482 7.90206 0.254482 8.38273C1.16782 14.0581 7.47782 20.0454 12.0005 21.6894C16.5225 20.0454 22.8331 14.0581 23.7451 8.38339C23.8585 7.90273 23.9238 7.40406 23.9238 6.88873Z",
    fill: "#DD2E44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartEmoji);
export default __webpack_public_path__ + "static/media/heart-emoji.3699b9c0ef940007480ee12ee2e33175.svg";
export { ForwardRef as ReactComponent };